module.exports = __webpack_public_path__ + "static/video-2668111d30e37eeabcdb9fce6d2c4ad3.png";